<template>
  <div class="filter-container">
    <validation-observer v-slot="{ passes }">
      <form novalidate @submit.prevent="passes(search)">
        <div class="row">
          <div class="col-3">
            <custom-drop-down
              v-model="model.companyType"
              :disabled="userCompanies.length == 1"
              fieldkey="id"
              fieldname="name"
              :options="companyTypes"
              placeholder="Tipo de Proveedor"
            />
          </div>

          <div class="col-3">
            <custom-drop-down
              v-model="model.status"
              fieldkey="value"
              fieldname="name"
              :options="statusOptions"
              placeholder="Estatus"
            />
          </div>

          <div class="col-3">
            <custom-drop-down
              v-model="model.company"
              :clearable="!userCompanies.length"
              :disabled="userCompanies.length == 1"
              fieldkey="id"
              fieldname="name"
              :options="providerListFiltered"
              placeholder="Proveedor"
            />
          </div>

          <div class="col-3">
            <action-button
              i="fas fa-search"
              text="Buscar"
              type="submit"
              variant="success"
            />
          </div>
        </div>
      </form>
    </validation-observer>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import { mapState, mapActions } from 'vuex';
import { name } from '@/modules/provider/store';
import roles from '@/utils/constants/roles.js';

const statusOptions = [
  { value: true, name: 'Activo' },
  { value: false, name: 'Inactivo' },
];

export default {
  name: 'ProviderSearchFilter',
  components: {
    CustomDropDown,
    ActionButton,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    statusOptions: statusOptions,
    filter: {
      companyType: null,
      status: statusOptions[0],
      company: null,
    },
  }),
  computed: {
    ...mapState(name, ['providersList', 'companyTypes']),
    ...mapState('$_user', ['user']),
    allowedToFilterBySsn() {
      return this.userHasPermissions('providers.access.all') || this.isCenter;
    },
    companyId() {
      return parseInt(this.user.profile.companyid);
    },
    isCenter() {
      return [
        roles.InterventorCentro,
        roles.DirectorCentro,
        roles.CentroIsla,
      ].includes(this.userRole);
    },
    userCompanies() {
      return this.$store.state['$_user'].companies;
    },
    providerListFiltered() {
      let filtered = this.providersList;

      if (this.model.status) {
        filtered = filtered.filter(
          (provider) => provider.active == this.model.status.value
        );
      }

      if (this.model.companyType) {
        filtered = filtered.filter(
          (provider) => provider.typeId == this.model.companyType.id
        );
      }

      return filtered;
    },
    model: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    providerListFiltered(newValue) {
      if (newValue.length == 1) {
        this.filter.company = newValue[0];
        this.filter.companyType = this.companyTypes.find(
          (c) => c.id == newValue[0].typeId
        );
      }
    },
  },
  methods: {
    ...mapActions(name, ['providersFilterList', 'getCompanyTypes']),
    search() {
      this.$emit('search');
    },
  },
  async mounted() {
    await this.getCompanyTypes();
    await this.providersFilterList();
    this.search();
  },
};
</script>

<style scoped lang="scss">
.filter-container {
  background-color: #f4f6f3;
  padding: 15px;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #aab7b1;
  font: 900 14px/17px Lato;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #aab7b1;
}

.separator::before {
  margin-right: 0.5em;
}

.separator::after {
  margin-left: 0.5em;
}

::v-deep .input-group {
  margin-bottom: 0 !important;

  label {
    display: flex;
    align-items: center;
  }
}
</style>
